import React from 'react'

const Spinner: React.FC = () => (
  <span style={{
    display: 'inline-block',
    width: '14px',
    height: '14px',
    border: '2px solid #e0e0e0',
    borderTop: '2px solid #e67e22',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
    verticalAlign: 'middle',
    marginRight: '6px',
  }} />
)

export default Spinner
